var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.productData)?_c('ImageEnhancementModal',{attrs:{"type":_vm.type,"product-data":_vm.productData,"application-group":_vm.applicationGroup,"index":_vm.index}}):_c('global-spinner-cst-spinner',{staticClass:"tw-top-0 tw-left-0"})}
var staticRenderFns = []

export { render, staticRenderFns }